import { render } from "./VehicleWithdrawalReportStatusTable.vue?vue&type=template&id=76fc40e3&ts=true"
import script from "./VehicleWithdrawalReportStatusTable.vue?vue&type=script&lang=ts"
export * from "./VehicleWithdrawalReportStatusTable.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./VehicleWithdrawalReportStatusTable.vue?vue&type=style&index=0&id=76fc40e3&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QSeparator,QTable,QTr,QTh,QTd});
